export default {
    name: 'pickupFulfillmentGroupPickingPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'pickupGroupPicking';
        const route = app.routes.getItem(routeName);

        if (route) {
            const routeProps = route.props;
            route.props = (state) => ({
                ...routeProps(state),
                correctOrderRequired: false,
                withLocationStep: false,
                withLocationScanner: false,
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
